module.exports = __webpack_public_path__ + "img/users_lock.b9013203.svg";